var a=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,t=function(t){return a.test(t)};export{t as _};
//# sourceMappingURL=_hasUnicodeWord.js.map
